<style lang="scss">
.ivu-select-multiple .ivu-tag {
    height: inherit !important;
    line-height: inherit !important;
    padding: 3px 8px 6px;
}
.hidefooter .ivu-modal-footer {
    display: block !important;
}
.searchb2c textarea.ivu-input {
    font-size: 12px;
}
</style>

<template>
    <div class="search-wrap searchb2c">
        <aside class="search-btn">
            <ButtonGroup>
                <Button
                    size="large"
                    v-for="(item, index) in btnsearch"
                    :key="index"
                    :type="
                        changestatus === item.value && changekeys === item.type
                            ? 'primary'
                            : 'default'
                    "
                    @click="handleBtn(item.type, item.value)"
                    >{{ item.label }}</Button
                >
                <compSearchCollect
                    style="display: inline-block"
                    size="large"
                    :dataList="collectList"
                    @on-click-item="handleClickCollect"
                    @on-delete-item="handleDeleteCollect"
                ></compSearchCollect>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-left">
                <Form :label-width="70" inline>
                    <FormItem
                        :label="
                            $t('global.common.organization', {
                                defaultValue: '组织',
                            })
                        "
                        style="width: 270px"
                    >
                        <Select
                            v-model="formData.IN_orgId"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in getOrgList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.channel', {
                                defaultValue: '渠道',
                            })
                        "
                        style="width: 270px"
                    >
                        <Select
                            v-model="formData.IN_channelId"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in accountsAll"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.createdtime', {
                                defaultValue: '创建时间',
                            })
                        "
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 200px"
                            ref="createdDate"
                            :value="getdate"
                            @on-change="createTime"
                        ></DatePicker>
                    </FormItem>
                </Form>
                <Form :label-width="70" inline>
                    <FormItem
                        :label="
                            $t('global.common.line', { defaultValue: '项目' })
                        "
                        style="width: 270px"
                    >
                        <Select
                            v-model="formData.IN_lineId"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in getNewAllProductList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_orderstatus', {
                                defaultValue: '订单状态',
                            })
                        "
                        style="width: 270px"
                    >
                        <Select
                            v-model="formData.IN_orderStatus"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in orderstatusList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordernumber', {
                                defaultValue: '订单号',
                            })
                        "
                    >
                        <Input
                            v-model="formData.EQ_orderNo"
                            style="width: 200px"
                            :placeholder="
                                $t('erp.b2c.placeholder_ordernumber', {
                                    defaultValue: '同时支持订单序号/订单号查询',
                                })
                            "
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div class="pull-right">
                <Form inline>
                    <Button
                        type="primary"
                        @click="update(true)"
                        icon="ios-search"
                        >{{
                            $t("global.common.btn_search", {
                                defaultValue: "查询",
                            })
                        }}</Button
                    >
                    <Button @click="resetdata" icon="md-refresh">{{
                        $t("global.common.btn_reset", { defaultValue: "重置" })
                    }}</Button>
                    <Button type="dashed" @click="isOpen = !isOpen">
                        {{
                            $t("global.common.btn_more", {
                                defaultValue: "更多查询",
                            })
                        }}
                        <Icon
                            type="ios-arrow-down"
                            class="margin-left-5"
                        ></Icon>
                    </Button>
                    <!-- <span style="float:right;cursor:pointer;margin-top:6px;margin-left:5px;">
                        <Tooltip :content="$t('global.common.helpword',{defaultValue:'帮助文档'})" placement="left">
                            <Icon @click="jumpHelp('http://help.thecopeservices.com/hc/kb/article/1521081/')" class="font-20" type="ios-help-circle-outline" />
                        </Tooltip>
                    </span> -->
                </Form>
                <!-- <Form inline class="margin-top-10"> -->
                <!-- <Button @click="handleModal('orderImport')" icon='md-refresh'>导入</Button> -->
                <!-- <Button @click="exportXlsx" icon='md-refresh'>查询条件导出</Button> -->
                <!-- </Form> -->
            </div>
        </article>
        <transition
            name="slide-both"
            @after-leave="changeSearch"
            @after-enter="changeSearch"
        >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordertype', {
                                defaultValue: '订单类型',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.IN_orderType"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in ordertypeList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>

                    <FormItem label="seller SKU" style="width: 330px">
                        <Input
                            clearable
                            v-model.trim="
                                formData['EQ_saleOrderItemsList.sellerSku']
                            "
                        />
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_outwarehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="orgWarehouseCodes"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in warehousesAll"
                                :value="item.value"
                                :key="index"
                            >
                                {{ item.label }} )
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.ordertime', {
                                defaultValue: '下单时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 200px"
                            ref="orderDate"
                            :value="getOrderDate"
                            @on-change="orderTime"
                        ></DatePicker>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_outtime', {
                                defaultValue: '发货时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 220px"
                            ref="shipmentDate"
                            :value="getshipdate"
                            @on-change="handleChange"
                        ></DatePicker>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.latest_time', {
                                defaultValue: '最晚发货时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 220px"
                            ref="latestShipDate"
                            :value="getlatesdate"
                            @on-change="handleChangelates"
                        ></DatePicker>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_outcategory', {
                                defaultValue: '发货类别',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            clearable
                            v-model="formData.EQ_fulfillmentChannel"
                            filterable
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in fulfillList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>

                    <FormItem label="ERPSKU" style="width: 330px">
                        <Input
                            clearable
                            v-model.trim="
                                formData['EQ_saleOrderItemsList.erpSku']
                            "
                        />
                    </FormItem>

                    <FormItem label="Tracking NO" style="width: 330px">
                        <Input
                            clearable
                            v-model.trim="
                                formData['EQ_saleShipmentPackagesList.trackNo']
                            "
                        />
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_state', {
                                defaultValue: '州/省份',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            clearable
                            v-model="formData['EQ_saleOrderAddressList.state']"
                            filterable
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in states"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordermark', {
                                defaultValue: '订单标记',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            clearable
                            v-model="formData.EQ_b2cOrderSign"
                            filterable
                        >
                            <Option
                                v-for="(item, index) in ordersignList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_isSFPorder', {
                                defaultValue: '是否SFP订单',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select clearable v-model="formData.EQ_isPrime">
                            <Option
                                v-for="(item, index) in primeList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_isbusiness', {
                                defaultValue: '是否Business',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select clearable v-model="formData.EQ_isBusinessOrder">
                            <Option
                                v-for="(item, index) in businessList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="Promotion ID" style="width: 330px">
                        <Input
                            clearable
                            v-model.trim="
                                formData['EQ_saleOrderItemsList.promotionIds']
                            "
                        />
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_errorcode', {
                                defaultValue: '异常类型',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.IN_errorCode"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in errorcodeList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="Po Number" style="width: 330px">
                        <Input clearable v-model.trim="formData.EQ_poNumber" />
                    </FormItem>
                    <!-- <FormItem :label="$t('erp.b2c.isOnsite',{defaultValue:'是否OnSite'})" style="width:330px;">
                        <Select clearable v-model="formData.EQ_isOnsite" :placeholder="$t('global.common.choose',{defaultValue:'请选择'})">
                            <Option
                                v-for="(item,index) in businessList"
                                :value="item.value"
                                :key="index"
                            >{{ item.label }}</Option>
                        </Select>
                    </FormItem> -->
                    <FormItem
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        style="width: 330px"
                    >
                        <!-- <Select dropStyle="width:auto"
                    v-model="formData.IN_shippingMethodCode"
                    filterable
                    multiple
                    :max-tag-count="2"
                    :placeholder="$t('global.common.choose',{defaultValue:'请选择'})">
              <Option v-for="(item,index) in serviceCodeList"
                      :value="item.value"
                      :key="index">{{ item.label }}</Option>
            </Select> -->

                        <compMultipleSelect
                            :options="serviceCodeList"
                            :modelValue="formData.IN_shippingMethodCode"
                            :placeholder="'请选择'"
                            @update:modelValue="changeShip"
                            :vstyle="'max-width:400px'"
                            :isShowCheckAll="false"
                        >
                        </compMultipleSelect>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.delivery_method', {
                                defaultValue: '出库方式',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            dropStyle="width:auto"
                            v-model="formData['EQ_orderClass']"
                            clearable
                            :placeholder="
                                $t('global.common.choose', {
                                    defaultValue: '请选择',
                                })
                            "
                        >
                            <Option
                                v-for="(item, index) in deliveryStatus"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.package_logistics_status', {
                                defaultValue: '物流状态',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            dropStyle="width:auto"
                            v-model="
                                formData[
                                    'IN_saleShipmentPackagesList.logisticStatus'
                                ]
                            "
                            filterable
                            multiple
                            :max-tag-count="2"
                            :placeholder="
                                $t('global.common.choose', {
                                    defaultValue: '请选择',
                                })
                            "
                        >
                            <Option
                                v-for="(item, index) in packStatus"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_channelorder', {
                                defaultValue: '渠道订单号',
                            })
                        "
                        style="width: 330px"
                    >
                        <Input
                            v-model="formData.IN_orderNo"
                            :rows="2"
                            :placeholder="
                                $t('erp.b2c.search_account', {
                                    defaultValue:
                                        '支持输入多个，一行一个渠道订单号',
                                })
                            "
                            type="textarea"
                        />
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.search_orderId', {
                                defaultValue: '订单ID',
                            })
                        "
                        style="width: 330px"
                    >
                        <Input
                            v-model="formData.IN_id"
                            :rows="2"
                            :placeholder="
                                $t('erp.b2c.search_ids', {
                                    defaultValue:
                                        '支持输入多个，一行一个订单ID',
                                })
                            "
                            type="textarea"
                        />
                    </FormItem>
                    <FormItem style="width: 330px">
                        <!-- <FormItem
                        :label="$t('erp.b2c.search_nochilder',{defaultValue:'子订单不展示'})"
                        style="width:330px;"
                    > -->
                        <!-- <vCheckbox v-model="formData.EQ_parentId" trueValue="0" falseValue></vCheckbox> -->
                        <Button
                            class="pull-left"
                            type="primary"
                            @click="handleShowModal"
                            >{{
                                $t("erp.b2corder.search.save_query", {
                                    defaultValue: "保存当前条件为收藏",
                                })
                            }}</Button
                        >
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form inline class="search-other">
                <Button
                    v-if="changekeys == '' || changekeys == 'NE_errorCode'"
                    class="margin-right-5 dark-primary"
                    @click="handleModal('resetorder')"
                    >{{
                        $t("erp.b2c.reset_order", { defaultValue: "重置订单" })
                    }}</Button
                >
                <Button
                    v-if="
                        changekeys == '' ||
                        changekeys == 'NE_errorCode' ||
                        changekeys == 'EQ_isActive'
                    "
                    type="info"
                    class="margin-right-5"
                    @click="handleModal('activeorder')"
                    >{{
                        $t("erp.b2c.active_order", { defaultValue: "激活订单" })
                    }}</Button
                >
                <Button
                    v-if="changekeys == '' || changekeys == 'NE_errorCode'"
                    type="warning"
                    class="margin-right-5"
                    @click="handleModal('backnormal')"
                    >{{
                        $t("erp.b2c.back_normal", { defaultValue: "恢复正常" })
                    }}</Button
                >
                <Button
                    v-if="changekeys == '' || changekeys == 'chaoshi'"
                    class="margin-right-5"
                    type="success"
                    @click="exportXlsx()"
                    >{{
                        $t("global.common.condition_export", {
                            defaultValue: "查询条件导出",
                        })
                    }}</Button
                >
                <!-- <Button v-if="changekeys=='' || changekeys=='NE_errorCode'" type="success" class="margin-right-5" @click="handleModal('project')">项目手动关联</Button> -->
                <Button
                    v-if="changekeys == '' || changekeys == 'EQ_isArtificial'"
                    class="margin-right-5 light-content"
                    @click="handleModal('passapprove')"
                    >{{
                        $t("erp.b2c.approved", { defaultValue: "审核通过" })
                    }}</Button
                >
                <Button
                    v-show="SYSID != 1000025"
                    class="margin-right-5"
                    type="info"
                    @click="handleModal('forcedpush')"
                    v-if="changekeys == '' || changekeys == 'NE_errorCode'"
                    >{{
                        $t("erp.b2c.pushyuncang", { defaultValue: "推送云仓" })
                    }}</Button
                >
                <Dropdown
                    trigger="hover"
                    v-show="SYSID != 1000025"
                    @on-click="handleModal"
                    v-if="changekeys == '' || changekeys == 'NE_errorCode'"
                >
                    <Button class="margin-right-5 middle-content">
                        {{
                            $t("erp.b2c.acquirecost", {
                                defaultValue: "成本获取",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="loadcost">{{
                            $t("erp.b2c.loadcost", { defaultValue: "加载成本" })
                        }}</DropdownItem>
                        <DropdownItem v-show="SYSID == 1" name="resetcost">{{
                            $t("erp.b2c.replacecost", {
                                defaultValue: "重置成本",
                            })
                        }}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <Dropdown
                    trigger="hover"
                    @on-click="handleModal"
                    v-if="changekeys == '' || changekeys == 'NE_errorCode'"
                    style="width: 120px"
                >
                    <Button type="error">
                        {{
                            $t("erp.b2c.bulkchanges", {
                                defaultValue: "批量修改",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                {{
                                    $t("erp.b2c.modify_order", {
                                        defaultValue: "修改订单类型",
                                    })
                                }}
                                <Icon type="ios-arrow-right"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem name="normalsales">{{
                                    $t("erp.b2c.ordertype_normally", {
                                        defaultValue: "正常销售",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="displayorder">{{
                                    $t("erp.b2c.ordertype_celebrity", {
                                        defaultValue: "展示订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="distributeorder">{{
                                    $t("erp.b2c.ordertype_distribution", {
                                        defaultValue: "分销订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="revieworder">{{
                                    $t("erp.b2c.ordertype_brush", {
                                        defaultValue: "刷评订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="deliveryOrder">{{
                                    $t("erp.b2c.ordertype_delivery", {
                                        defaultValue: "发货订单",
                                    })
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                {{
                                    $t("erp.b2c.addorder_mark", {
                                        defaultValue: "增加订单标记",
                                    })
                                }}
                                <Icon type="ios-arrow-right"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem name="reissueorder">{{
                                    $t("erp.b2c.replacement_order", {
                                        defaultValue: "补发订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="redpeopleorder">{{
                                    $t("erp.b2c.redpeople_order", {
                                        defaultValue: "红人订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="sampleorder">{{
                                    $t("erp.b2c.sample_order", {
                                        defaultValue: "样品订单",
                                    })
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <!--<DropdownItem name="modifylogistics">{{$t('erp.b2c.modify_logistics',{defaultValue:'修改仓库物流'})}}</DropdownItem>-->
                        <DropdownItem name="addnotes">{{
                            $t("erp.b2c.add_notes", {
                                defaultValue: "添加备注",
                            })
                        }}</DropdownItem>
                        <DropdownItem name="submitabnormal">{{
                            $t("erp.b2c.submit_abnormal", {
                                defaultValue: "提交异常",
                            })
                        }}</DropdownItem>
                        <DropdownItem name="batchcancel">{{
                            $t("fbb.alloment.muti_cancel", {
                                defaultValue: "批量取消",
                            })
                        }}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown
                    class="pull-right"
                    trigger="hover"
                    v-if="changekeys != 'chaoshi'"
                    @on-click="handleModal"
                >
                    <Button type="info">
                        {{
                            $t("global.common.import_export", {
                                defaultValue: "导入/出",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <!--<DropdownItem name="orderImport" v-show="routerName=='b2cOrder'">{{$t('erp.b2c.manucal_import',{defaultValue:'手动导入'})}}</DropdownItem>
                        <DropdownItem name="deliveryOrderImport" v-show="routerName=='b2cOrder'">{{$t('erp.b2c.invoice_import',{defaultValue:'发货单导入'})}}</DropdownItem>-->
                        <DropdownItem>
                            <div @click="exportXlsx">
                                {{
                                    $t("global.common.condition_export", {
                                        defaultValue: "查询条件导出",
                                    })
                                }}
                            </div>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </Form>
        </transition>
        <Modal
            v-model="modalProps.show"
            :mask-closable="false"
            :footer-hide="true"
            :title="modalProps.title"
            v-bind="modalProps"
        >
            <Spin v-if="modalProps.modalLoading" fix></Spin>
            <Form :model="modalData" :labelWidth="80">
                <FormItem
                    :label="
                        $t('erp.b2corder.serach_query_name', {
                            defaultValue: '查询名称',
                        })
                    "
                    prop="searchName"
                >
                    <Input
                        :placeholder="
                            $t('erp.b2corder.search_please_enter_name', {
                                defaultValue: '请输入名称',
                            })
                        "
                        v-model="modalData.searchName"
                    />
                </FormItem>
            </Form>
            <div>
                <Button
                    class="margin-right-15"
                    type="primary"
                    @click="saveSearch"
                    >{{
                        $t("global.modal.confirm", { defaultValue: "确定" })
                    }}</Button
                >
                <Button type="default" @click="cancelModal">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { HttpGroupRuleItem } from "@/service/boss/allot";
import compSearchCollect from "@/views/components/searchcollect.vue";
import {
    HttpGetStates,
    HttpGetAllCustomerIdCode,
    HttpGetSearchCollect,
    HttpAddSearchCollect,
    HttpDeleteSearchCollect,
    HttpGetSearchCollectById,
} from "@/service/boss/b2corder";
import warehouseMixin from "../../warehouseMixin";
import { mapState, mapGetters } from "vuex";

export default {
    components: {
        compSearchCollect,
    },
    mixins: [warehouseMixin],
    data() {
        return {
            SYSID: "",
            aaaa: "",
            isOpen: false,
            orgWarehouseCodes: [],
            getdate: [],
            getOrderDate: [],
            getshipdate: [],
            getlatesdate: [],
            routerName: this.$route.name,
            states: [],
            formData: {
                NE_errorCode: "",
                EQ_isArtificial: "",
                EQ_isActive: "",
                IN_orgId: [],
                chaoshi: "",
                IN_channelId: [],
                IN_orderStatus: [],
                GE_channelCreated: "",
                LE_channelCreated: "",
                "GE_saleOrderDetails.accountLocalTime": "",
                "LE_saleOrderDetails.accountLocalTime": "",
                IN_lineId: [],
                IN_errorCode: [],
                EQ_orderNo: "",
                // 下拉框的查询字段
                IN_orderType: [],
                "EQ_saleOrderItemsList.sellerSku": "",
                IN_orgWarehouseId: [],
                GE_shipmentDate: "",
                LE_shipmentDate: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                EQ_fulfillmentChannel: "",
                "EQ_saleOrderItemsList.erpSku": "",
                "EQ_saleShipmentPackagesList.trackNo": "",
                "EQ_saleOrderAddressList.state": "",

                EQ_b2cOrderSign: "",
                EQ_isPrime: "",
                EQ_isBusinessOrder: "",
                "EQ_saleOrderItemsList.promotionIds": "",
                EQ_orderClass: "",
                "IN_saleShipmentPackagesList.logisticStatus": "",
                EQ_isAddition: "",

                IN_orderNo: "",
                IN_id: "",
                EQ_parentId: "",

                EQ_poNumber: "",
                EQ_isOnsite: "",
                IN_shippingMethodCode: "",
            },
            allisAddition: "",
            changestatus: "",
            changekeys: "",
            serviceCodeList: [],
            collectList: [],
            modalProps: {
                show: false,
                modalLoading: false,
            },
            modalData: {
                searchName: "",
            },
        };
    },
    created() {
        let b2cflag = localStorage.getItem("b2cflag");
        if (!b2cflag) {
            // console.log(3334566)
            if (this.changekeys == "") {
                this.timehandle();
            } else {
                this.getdate = [];
                this.getOrderDate = [];
                this.getshipdate = [];
            }
        }
        HttpGetAllCustomerIdCode().then(
            (res) => {
                // console.log(res)
                this.serviceCodeList = res.data.map((item) => {
                    return {
                        label: `${item.code}(${item.carrierServiceName})`,
                        value: item.code,
                        attach: {
                            ...item,
                        },
                    };
                });
            },
            (err) => {
                console.log(err);
            }
        );
    },
    mounted() {
        this.getSearchCollect();
        this.update();
        this.bus.$on("changelang", (val) => {
            setTimeout(() => {
                this.update(true);
            }, 600);
        });
    },
    computed: {
        deliveryStatus() {
            return [
                {
                    value: "b2c",
                    label: this.$t("erp.b2c.direct_issue", {
                        defaultValue: "直接出库",
                    }),
                },
                {
                    value: "b2b",
                    label: this.$t("erp.b2c.goods_collection", {
                        defaultValue: "集货出库-不上报打托信息",
                    }),
                },
                {
                    value: "b2b_pla",
                    label: this.$t("erp.b2c.goods_collection_underpinning", {
                        defaultValue: "集货出库-上报打托信息",
                    }),
                },
            ];
        },
        packStatus() {
            return [
                {
                    value: 0,
                    label: "UNKNOWN",
                    color: "",
                },
                {
                    value: 1,
                    label: "PRE TRANSIT",
                    color: "color-success",
                },
                {
                    value: 2,
                    label: "IN TRANSIT",
                    color: "color-primary",
                },
                {
                    value: 3,
                    label: "OUT FOR DELIVERY",
                    color: "color-warning",
                },
                {
                    value: 4,
                    label: "DELIVERED",
                    color: "",
                },
                {
                    value: 5,
                    label: "AVAILABLE FOR PICKUP",
                    color: "color-success",
                },
                {
                    value: 6,
                    label: "RETURN TO SENDER",
                    color: "color-error",
                },
                {
                    value: 7,
                    label: "FAILURE",
                    color: "color-error",
                },
                {
                    value: 8,
                    label: "CANCELLED",
                    color: "",
                },
                {
                    value: 9,
                    label: "ERROR",
                    color: "color-error",
                },
                {
                    value: 11,
                    label: "Label Created",
                    color: "",
                },
            ];
        },
        btnsearch() {
            return [
                {
                    value: "",
                    type: "",
                    label: this.$t("erp.b2c.all_order", {
                        defaultValue: "所有订单",
                    }),
                },
                {
                    value: "unexception",
                    type: "NE_errorCode",
                    label: this.$t("erp.b2c.abnormal_order", {
                        defaultValue: "异常订单",
                    }),
                },
                {
                    value: "Y",
                    type: "EQ_isArtificial",
                    label: this.$t("erp.b2c.people_review", {
                        defaultValue: "待人工审核订单",
                    }),
                },
                {
                    value: "N",
                    type: "EQ_isActive",
                    label: this.$t("erp.b2c.actived_order", {
                        defaultValue: "待激活订单",
                    }),
                },
                {
                    value: "",
                    type: "chaoshi",
                    label: this.$t("erp.b2c.timeout_order", {
                        defaultValue: "超时订单",
                    }),
                },
            ];
        },
        // 订单状态
        orderstatusList() {
            return [
                {
                    value: "pending",
                    label: this.$t("erp.b2c.orderstatus_pending", {
                        defaultValue: "未支付",
                    }),
                },
                {
                    value: "unshipped",
                    label: this.$t("erp.b2c.orderstatus_unshipped", {
                        defaultValue: "未发货",
                    }),
                },
                {
                    value: "approved",
                    label: this.$t("erp.b2c.orderstatus_approved", {
                        defaultValue: "已审核",
                    }),
                },
                // {
                //     value: "assigned",
                //     label: this.$t("erp.b2c.orderstatus_assigned", {
                //         defaultValue: "已分配",
                //     }),
                // },
                {
                    value: "picked",
                    label: this.$t("erp.b2c.orderstatus_picked", {
                        defaultValue: "已配货",
                    }),
                },
                {
                    value: "shipped",
                    label: this.$t("erp.b2c.orderstatus_shipped", {
                        defaultValue: "已发货",
                    }),
                },
                {
                    value: "canceled",
                    label: this.$t("erp.b2c.orderstatus_canceled", {
                        defaultValue: "已取消",
                    }),
                },
            ];
        },
        // 异常订单
        errorcodeList() {
            return [
                {
                    value: "unexception",
                    label: "Unexception" + "(无异常)",
                },
                {
                    value: "systemException",
                    label: "System Exception" + "(系统异常)",
                },
                {
                    value: "configurationException",
                    label: "configuration Exception" + "(配置异常)",
                },
                {
                    value: "produceException",
                    label: "Order Product Exception" + "(商品无法关联)",
                },
                {
                    value: "addressException",
                    label: "Order Address Exception" + "(订单地址异常)",
                },
                {
                    value: "updateException",
                    label: "Order Update Exception" + "(订单更新异常)",
                },
                {
                    value: "insufficientInventoryException",
                    label: "Out Of Stock Exception" + "(库存不足异常)",
                },
                {
                    value: "deliverOrderCancelException",
                    label:
                        "Shipment Order Cancel Exception" + "(发货单取消异常)",
                },
                {
                    value: "pickingException",
                    label: "Order Distribution Exception" + "(订单配货异常)",
                },
                {
                    value: "cancelException",
                    label: "Order Cancellation Exception" + "(订单取消异常)",
                },
                {
                    value: "trackingException",
                    label: "Order Tracking Exception" + "(Tracking异常)",
                },
                {
                    value: "costException",
                    label: "Order Cost Exception" + "(订单成本异常)",
                },
                {
                    value: "carrierException",
                    label: "Order Carrier Exception" + "(订单发运方式异常)",
                },
                {
                    value: "uploadException",
                    label:
                        "Order Attachment Upload Exception" +
                        "(订单附件上传异常)",
                },
                {
                    value: "purchaseException",
                    label: "Shipping label generating error" + "(购买面单异常)",
                },
            ];
        },
        // 订单类型
        ordertypeList() {
            return [
                {
                    value: "normally",
                    label: this.$t("erp.b2c.ordertype_normally", {
                        defaultValue: "正常销售",
                    }),
                },
                {
                    value: "celebrity",
                    label: this.$t("erp.b2c.ordertype_celebrity", {
                        defaultValue: "展示订单",
                    }),
                },
                {
                    value: "distribution",
                    label: this.$t("erp.b2c.ordertype_distribution", {
                        defaultValue: "分销订单",
                    }),
                },
                {
                    value: "brush",
                    label: this.$t("erp.b2c.ordertype_brush", {
                        defaultValue: "刷评订单",
                    }),
                },
                {
                    value: "DELIVERY",
                    label: this.$t("erp.b2c.ordertype_delivery", {
                        defaultValue: "发货订单",
                    }),
                },
            ];
        },
        // 发货类别
        fulfillList() {
            return [
                { value: "AFN", label: "AFN" },
                { value: "MFN", label: "MFN" },
            ];
        },

        // 订单标记
        ordersignList() {
            return [
                {
                    value: "celebrity",
                    label: this.$t("erp.b2c.redpeople_order", {
                        defaultValue: "红人订单",
                    }),
                },
                {
                    value: "sample",
                    label: this.$t("erp.b2c.sample_order", {
                        defaultValue: "样品订单",
                    }),
                },
                {
                    value: "reshipment",
                    label: this.$t("erp.b2c.replacement_order", {
                        defaultValue: "补发订单",
                    }),
                },
                {
                    value: "addition",
                    label: this.$t("erp.b2c.gift_order", {
                        defaultValue: "礼品订单",
                    }),
                },
                // {
                //     value: "disassemblyParent",
                //     label: this.$t("erp.b2c.unpackparent_order", {
                //         defaultValue: "拆解父订单",
                //     }),
                // },
                // {
                //     value: "disassemblyChild",
                //     label: this.$t("erp.b2c.unpackson_order", {
                //         defaultValue: "拆解子订单",
                //     }),
                // },
            ];
        },
        // SFP订单
        primeList() {
            return [
                {
                    value: "Y",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "N",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
        // Business
        businessList() {
            return [
                {
                    value: "Y",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "N",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
        options() {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.recent_month", {
                            defaultValue: "最近一月",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.latest_quarter", {
                            defaultValue: "最近一季度",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            return [start, end];
                        },
                    },
                ],
            };
        },
        ...mapGetters("diction", [
            "getNewAllProductList",
            "getNewAllAccountIdList",
        ]),
        ...mapGetters("dictionary", [
            "getOrgList",
            "getNewAllWarehouseIdList",
            "getCarrierCusList",
        ]),
        // ...mapState("boss", ["sysshippingcode"]),
        warehousesAll() {
            let existCode = [];
            let arr = [];
            this.warehouseList.map((item) => {
                // console.log(item)
                if (existCode.indexOf(item.attach.code) < 0) {
                    existCode.push(item.attach.code);
                    // console.log(existCode)
                    let json = {
                        value: item.attach.code,
                        label: item.label,
                    };
                    arr.push(json);
                }
            });
            // console.log(arr)
            return arr;
        },
        accountsAll() {
            return this.getNewAllAccountIdList.sort(function (a, b) {
                return a.label.localeCompare(b.label);
            });
        },
        orgname(item) {
            //console.log(item.orgId)
            const orgId = item.orgId;
            const _this = this;
            //console.log(_this.getOrgList)
            const org =
                _this.getOrgList.filter((items) => {
                    orgId == items.id;
                })[0] || {};
            // console.log(org.label+"-------------------")
            return org;
        },
        newtimes() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        propsData() {
            return [
                {
                    label: this.$t("global.common.organization", {
                        defaultValue: "组织",
                    }),
                    key: "IN_orgId",
                    tag: "Select",
                    value: this.getOrgList,
                },
                {
                    label: this.$t("global.common.channel", {
                        defaultValue: "渠道",
                    }),
                    key: "IN_channelId",
                    tag: "Select",
                    value: this.accountsAll,
                },
                {
                    label: this.$t("erp.b2c.search_orderstatus", {
                        defaultValue: "订单状态",
                    }),
                    key: "IN_orderStatus",
                    tag: "Select",
                    value: this.orderstatusList,
                },
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: ["GE_channelCreated", "LE_channelCreated"],
                    tag: "timearray",
                },
                {
                    label: this.$t("global.common.ordertime", {
                        defaultValue: "下单时间",
                    }),
                    key: [
                        "GE_saleOrderDetails.accountLocalTime",
                        "LE_saleOrderDetails.accountLocalTime",
                    ],
                    tag: "timearray",
                },
                {
                    label: this.$t("global.common.line", {
                        defaultValue: "项目",
                    }),
                    key: "IN_lineId",
                    tag: "Select",
                    value: this.getNewAllProductList,
                },
                {
                    label: this.$t("erp.b2c.search_errorcode", {
                        defaultValue: "异常类型",
                    }),
                    key: "IN_errorCode",
                    tag: "Select",
                    value: this.errorcodeList,
                },
                {
                    label: this.$t("erp.b2c.search_ordernumber", {
                        defaultValue: "订单号",
                    }),
                    key: "EQ_orderNo",
                },
                {
                    label: this.$t("erp.b2c.search_ordertype", {
                        defaultValue: "订单类型",
                    }),
                    key: "IN_orderType",
                    tag: "Select",
                    value: this.ordertypeList,
                },
                { label: "seller SKU", key: "EQ_saleOrderItemsList.sellerSku" },
                {
                    label: this.$t("erp.b2c.search_outwarehouse", {
                        defaultValue: "发货仓库",
                    }),
                    key: "orgWarehouseCodes",
                    tag: "Select",
                    value: this.warehousesAll,
                    deletetag: "deletetag",
                },
                {
                    label: this.$t("erp.b2c.search_outtime", {
                        defaultValue: "发货时间",
                    }),
                    key: ["GE_shipmentDate", "LE_shipmentDate"],
                    tag: "timearray",
                },
                {
                    label: this.$t("erp.b2c.latest_time", {
                        defaultValue: "最晚发货时间",
                    }),
                    key: ["GE_latestShipDate", "LE_latestShipDate"],
                    tag: "timearray",
                },
                {
                    label: this.$t("erp.b2c.search_outcategory", {
                        defaultValue: "发货类别",
                    }),
                    key: "EQ_fulfillmentChannel",
                    tag: "Select",
                    value: this.fulfillList,
                },
                { label: "ERPSKU", key: "EQ_saleOrderItemsList.erpSku" },
                {
                    label: "Tracking NO",
                    key: "EQ_saleShipmentPackagesList.trackNo",
                },
                {
                    label: this.$t("erp.b2c.search_state", {
                        defaultValue: "州/省份",
                    }),
                    key: "EQ_saleOrderAddressList.state",
                    tag: "Select",
                    value: this.states,
                },
                {
                    label: this.$t("erp.b2c.search_ordermark", {
                        defaultValue: "订单标记",
                    }),
                    key: "EQ_b2cOrderSign",
                    tag: "Select",
                    value: this.ordersignList,
                },
                {
                    label: this.$t("erp.b2c.search_isSFPorder", {
                        defaultValue: "是否SFP订单",
                    }),
                    key: "EQ_isPrime",
                    tag: "Select",
                    value: this.primeList,
                },
                {
                    label: this.$t("erp.b2c.search_isbusiness", {
                        defaultValue: "是否Business",
                    }),
                    key: "EQ_isBusinessOrder",
                    tag: "Select",
                    value: this.businessList,
                },
                {
                    label: "Promotion ID",
                    key: "EQ_saleOrderItemsList.promotionIds",
                },
                { label: "Po Number", key: "EQ_poNumber" },
                // {label:this.$t('erp.b2c.isOnsite',{defaultValue:'是否Onsite'}),key:'EQ_isOnsite',value:this.businessList},
                {
                    label: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "IN_shippingMethodCode",
                    tag: "Select",
                    value: this.serviceCodeList,
                },
                {
                    label: this.$t("erp.b2c.delivery_method", {
                        defaultValue: "出库方式",
                    }),
                    key: "EQ_orderClass",
                    tag: "Select",
                    value: this.deliveryStatus,
                },
                {
                    label: this.$t("erp.b2c.package_logistics_status", {
                        defaultValue: "物流状态",
                    }),
                    key: "IN_saleShipmentPackagesList.logisticStatus",
                    tag: "Select",
                    value: this.packStatus,
                },
                {
                    label: this.$t("erp.b2c.search_channelorder", {
                        defaultValue: "渠道订单号",
                    }),
                    key: "IN_orderNo",
                    text: "text",
                },
                {
                    label: this.$t("erp.b2c.search_orderId", {
                        defaultValue: "订单ID",
                    }),
                    key: "IN_id",
                    text: "text",
                },
            ];
        },
    },
    methods: {
        // 切换发货方式
        changeShip(val) {
            this.formData.IN_shippingMethodCode = val;
        },
        handleShowModal() {
            this.modalProps.show = true;
            this.modalProps.title = this.$t(
                "erp.b2corder.search_create_fast_query_name",
                { defaultValue: "创建快捷查询名称" }
            );
        },
        cancelModal() {
            this.modalProps.show = false;
            this.modalData = {};
        },
        handleClickCollect(item) {
            // let formData = {};
            this.resetformdata();
            this.formData["GE_channelCreated"] = "";
            this.formData["LE_channelCreated"] = "";
            this.formData["GE_saleOrderDetails.accountLocalTime"] = "";
            this.formData["LE_saleOrderDetails.accountLocalTime"] = "";
            this.orgWarehouseCodes = [];
            let dateArray = [];
            let orderArray = [];
            item.items.map((searchItem) => {
                let searchData = searchItem.searchData;
                if (searchItem.searchOpField === "orgWarehouseCodes") {
                    this.orgWarehouseCodes = searchItem.searchData.split("$");
                    return;
                }
                // string
                if (searchItem.searchData.indexOf("$") !== -1) {
                    if (searchItem.searchData.indexOf("$") === 0) {
                        searchData = searchItem.searchData.replace("$", "");
                    } else {
                        searchData = searchItem.searchData.split("$");
                    }
                }
                // number
                else if (searchItem.searchData.indexOf("#") !== -1) {
                    if (searchItem.searchData.indexOf("#") === 0) {
                        searchData = searchItem.searchData.replace("#", "");
                        console.log(searchData);
                        searchData = parseInt(searchData);
                    } else {
                        searchData = searchItem.searchData.split("#");
                        searchData = searchData.map((id) => {
                            return parseInt(id);
                        });
                    }
                }
                if (
                    searchItem.searchOpField == "GE_channelCreated" ||
                    searchItem.searchOpField == "LE_channelCreated"
                ) {
                    dateArray.push(searchItem.searchData);
                }
                if (
                    searchItem.searchOpField ==
                        "GE_saleOrderDetails.accountLocalTime" ||
                    searchItem.searchOpField ==
                        "LE_saleOrderDetails.accountLocalTime"
                ) {
                    orderArray.push(searchItem.searchData);
                }
                this.$set(this.formData, searchItem.searchOpField, searchData);
                // formData[searchItem.searchOpField] = searchData;
            });
            if (dateArray.length) this.getdate = dateArray;
            if (orderArray.length) this.getOrderDate = orderArray;
            // console.log(formData)
            // formData = {
            //     ...this.formData,
            //     ...formData
            // }

            // this.$set(this, 'formData', formData);
            console.log(this.formData);
            this.update(true);
        },
        saveSearch() {
            // console.log(this.formData);
            let formDataArray = [];
            console.log(this.formData);
            Object.keys(this.formData).map((key) => {
                if (this.formData[key]) {
                    // Tab数据不保存
                    if (
                        key == "NE_errorCode" ||
                        key == "EQ_isArtificial" ||
                        key == "EQ_isActive" ||
                        key == "chaoshi"
                    )
                        return;
                    console.log("key", key, "value", this.formData[key]);
                    if (Array.isArray(this.formData[key])) {
                        if (this.formData[key].length) {
                            let flag = "$";
                            if (typeof this.formData[key][0] === "string") {
                                flag = "$";
                            } else if (
                                typeof this.formData[key][0] === "number"
                            ) {
                                flag = "#";
                            }
                            let data = {};
                            if (this.formData[key].length < 2) {
                                data = {
                                    searchOpField: key,
                                    searchData: flag + this.formData[key][0],
                                };
                            } else {
                                data = {
                                    searchOpField: key,
                                    searchData: this.formData[key].join(flag),
                                };
                            }
                            formDataArray.push(data);
                        }
                    } else {
                        let value = this.formData[key];
                        if (typeof value === "number") {
                            value = "#" + value;
                        }
                        let data = {
                            searchOpField: key,
                            searchData: value,
                        };
                        formDataArray.push(data);
                    }
                }
            });
            if (this.orgWarehouseCodes.length > 0) {
                let data = {
                    searchOpField: "orgWarehouseCodes",
                    searchData: this.orgWarehouseCodes.join("$"),
                };
                formDataArray.push(data);
            }
            if (!formDataArray.length)
                return this.$VMessage.error(
                    this.$t("erp.b2corder.search_warning_query_one", {
                        defaultValue: "至少填写一组查询条件",
                    })
                );
            if (!this.modalData.searchName)
                return this.$VMessage.error(
                    this.$t("erp.b2corder.search_warning.query_name_not_null", {
                        defaultValue: "查询名称不能为空",
                    })
                );
            this.modalProps.modalLoading = true;
            HttpAddSearchCollect({
                orgId: global.SYSID,
                module: "orderAdmin",
                searchName: this.modalData.searchName,
                items: formDataArray,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.getSearchCollect();
                        this.cancelModal();
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.modalProps.modalLoading = false;
                });
        },
        getSearchCollect() {
            // stage环境暂时隐藏查询收藏
            let isStage = location.host.indexOf("stage") >= 0 ? true : false;
            if (isStage) return (this.collectList = []);
            HttpGetSearchCollect({
                module: "orderAdmin",
            }).then(
                (res) => {
                    console.log(res);
                    this.collectList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleDeleteCollect(item) {
            this.$parent.handleDeleteSearch((callback) => {
                HttpDeleteSearchCollect({
                    ids: item.id,
                })
                    .then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.getSearchCollect();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    )
                    .finally(() => {
                        callback();
                    });
            });
        },
        async changeSearch() {
            await this.$nextTick();
            this.$emit("on-change-search");
        },
        timehandle() {
            // if()
            this.formData.GE_channelCreated = this.getDay(-7);
            this.formData.LE_channelCreated = this.getDay(0);
            this.getdate = [
                this.formData.GE_channelCreated,
                this.formData.LE_channelCreated,
            ];
            //   this.formData["GE_saleOrderDetails.accountLocalTime"] = this.getDay(-7);
            //   this.formData["LE_saleOrderDetails.accountLocalTime"] = this.getDay(0);
            //   this.getOrderDate = [
            //     this.formData["GE_saleOrderDetails.accountLocalTime"],
            //     this.formData["LE_saleOrderDetails.accountLocalTime"],
            //   ];
        },
        // 封装时间函数
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds =
                today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear + "-" + tMonth + "-" + tDate;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        update(type, parms) {
            if (!this.formData.GE_channelCreated) {
                this.getdate = [];
            } else {
                this.getdate = [
                    this.formData.GE_channelCreated,
                    this.formData.LE_channelCreated,
                ];
            }
            if (!this.formData["GE_saleOrderDetails.accountLocalTime"]) {
                this.getOrderDate = [];
            } else {
                this.getOrderDate = [
                    this.formData["GE_saleOrderDetails.accountLocalTime"],
                    this.formData["LE_saleOrderDetails.accountLocalTime"],
                ];
            }
            if (this.formData.IN_orderNo != "") {
                if (!(this.formData.IN_orderNo instanceof Array)) {
                    let INorderNo = this.formData.IN_orderNo.replace(
                        /\n/g,
                        ","
                    );
                    this.formData.IN_orderNo = INorderNo.split(",");
                }
            }
            if (this.formData.IN_id != "") {
                if (!(this.formData.IN_id instanceof Array)) {
                    let INid = this.formData.IN_id.replace(/\n/g, ",");
                    this.formData.IN_id = INid.split(",");
                }
            }
            if (
                this.formData.IN_orderNo.length > 151 ||
                this.formData.IN_id.length > 151
            ) {
                this.$Message.error(
                    this.$t("erp.b2c.alert_morethan150", {
                        defaultValue: "渠道订单号或订单ID输入不能超过150条",
                    })
                );
                return;
            }
            // 当查询订单的时候去掉时间
            if (this.formData.EQ_orderNo || this.formData.EQ_poNumber) {
                this.getdate = [];
                this.formData.GE_channelCreated = "";
                this.formData.LE_channelCreated = "";
                this.getOrderDate = [];
                this.formData["GE_saleOrderDetails.accountLocalTime"] = "";
                this.formData["LE_saleOrderDetails.accountLocalTime"] = "";
            }
            // 点击查询按钮
            if (type == true && this.changekeys === "") {
                localStorage.setItem(
                    "b2csearch",
                    JSON.stringify(this.formData)
                );
                localStorage.setItem("b2cflag", true);
            }
            let b2csearch = localStorage.getItem("b2csearch");
            if (b2csearch) {
                let b2cFormData = JSON.parse(b2csearch);
                this.formData = b2cFormData;
                this.getdate = [
                    this.formData.GE_channelCreated,
                    this.formData.LE_channelCreated,
                ];
                this.getOrderDate = [
                    this.formData["GE_saleOrderDetails.accountLocalTime"],
                    this.formData["LE_saleOrderDetails.accountLocalTime"],
                ];
                this.getshipdate = [
                    this.formData.GE_shipmentDate,
                    this.formData.LE_shipmentDate,
                ];
                this.getlatesdate = [
                    this.formData.GE_latestShipDate,
                    this.formData.LE_latestShipDate,
                ];
                // console.log(b2cFormData)
            }

            if (type == "search") {
                let orders = {
                    NE_errorCode: "",
                    EQ_isArtificial: "",
                    EQ_isActive: "",
                    chaoshi: "",
                };
                for (var keys in orders) {
                    if (keys == parms.btnkey) {
                        this.$set(this.formData, parms.btnkey, parms.btnval);
                    } else {
                        this.$set(this.formData, keys, orders[keys]);
                    }
                }
                this.$set(this.formData, parms.btnkey, parms.btnval);
            }
            this.allisAddition = "";
            if (this.formData.EQ_parentId == true) {
                this.formData.EQ_parentId = 0;
            }
            if (this.changekeys == "chaoshi") {
                this.$emit("on-update", {
                    timeoutFlag: 1,
                    orgWarehouseCodes: this.orgWarehouseCodes,
                    search: {
                        ...this.formData,
                        EQ_isAddition: "",
                    },
                });
            } else {
                this.$emit("on-update", {
                    timeoutFlag: 0,
                    orgWarehouseCodes: this.orgWarehouseCodes,
                    search: {
                        ...this.formData,
                        EQ_isAddition: "",
                    },
                });
            }
            HttpGetStates({
                "search[EQ_depth]": 4,
            }).then(
                (res) => {
                    this.states = res.data.map((item) => {
                        return {
                            label: item.code + "(" + item.nameEn + ")",
                            value: item.code ? item.code : item.nameEn,
                        };
                    });
                    this.SYSID = global.SYSID;
                },
                (err) => {}
            );
        },
        resetdata() {
            this.$refs.createdDate.handleClear();
            this.$refs.orderDate.handleClear();
            this.$refs.shipmentDate.handleClear();
            this.$refs.latestShipDate.handleClear();
            localStorage.removeItem("b2csearch");
            localStorage.removeItem("b2cflag");
            if (this.changekeys == "") {
                // console.log(1111)
                this.timehandle();
            } else {
                // console.log(3333)
                this.getdate = [];
                this.getOrderDate = [];
                this.getshipdate = [];
            }
            this.orgWarehouseCodes = "";
            this.resetformdata();
            this.allisAddition = "";
            this.$emit("on-update", {
                search: {
                    orgWarehouseCodes: (this.orgWarehouseCodes = ""),
                    ...this.formData,
                    EQ_isAddition: "",
                },
            });
        },
        resetformdata() {
            this.formData = {
                NE_errorCode: this.formData.NE_errorCode,
                EQ_isArtificial: this.formData.EQ_isArtificial,
                EQ_isActive: this.formData.EQ_isActive,
                IN_channelId: [],
                IN_orgId: [],
                IN_orderStatus: [],
                GE_channelCreated: this.getdate[0],
                LE_channelCreated: this.getdate[1],
                IN_lineId: [],
                IN_errorCode: [],
                EQ_orderNo: "",
                IN_orderType: [],
                "GE_saleOrderDetails.accountLocalTime": this.getOrderDate[0],
                "LE_saleOrderDetails.accountLocalTime": this.getOrderDate[1],
                "EQ_saleOrderItemsList.sellerSku": "",
                IN_orgWarehouseId: [],
                GE_shipmentDate: "",
                LE_shipmentDate: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                EQ_fulfillmentChannel: "",
                "EQ_saleOrderItemsList.erpSku": "",
                "EQ_saleShipmentPackagesList.trackNo": "",
                "EQ_saleOrderAddressList.state": "",

                EQ_b2cOrderSign: "",
                EQ_isPrime: "",
                EQ_isBusinessOrder: "",
                "EQ_saleOrderItemsList.promotionIds": "",
                EQ_orderClass: "",
                "IN_saleShipmentPackagesList.logisticStatus": "",

                IN_orderNo: "",
                IN_id: "",

                EQ_poNumber: "",
                EQ_isOnsite: "",
                IN_shippingMethodCode: "",
                EQ_parentId: "",
            };
        },
        exportXlsx() {
            if (sessionStorage.getItem("downloadTotal") > 30000) {
                this.$Message.error(
                    this.$t("erp.b2c.alert_morethanother", {
                        defaultValue: "导出数据不要超过",
                    }) + "30000"
                );
            } else {
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BOSS +
                        "/api/v2/B2cOrder/exportXlsx",
                    {
                        "search[NE_errorCode]": this.formData.NE_errorCode
                            ? this.formData.NE_errorCode
                            : "",
                        "search[EQ_isArtificial]": this.formData.EQ_isArtificial
                            ? this.formData.EQ_isArtificial
                            : "",
                        "search[EQ_isActive]": this.formData.EQ_isActive
                            ? this.formData.EQ_isActive
                            : "",
                        "search[IN_channelId]": this.formData.IN_channelId
                            ? this.formData.IN_channelId
                            : "",
                        "search[IN_orderStatus]": this.formData.IN_orderStatus
                            ? this.formData.IN_orderStatus
                            : "",
                        "search[GE_channelCreated]": this.formData
                            .GE_channelCreated
                            ? this.formData.GE_channelCreated
                            : "",
                        "search[LE_channelCreated]": this.formData
                            .LE_channelCreated
                            ? this.formData.LE_channelCreated
                            : "",
                        "search[GE_saleOrderDetails.accountLocalTime]": this
                            .formData["GE_saleOrderDetails.accountLocalTime"]
                            ? this.formData[
                                  "GE_saleOrderDetails.accountLocalTime"
                              ]
                            : "",
                        "search[LE_saleOrderDetails.accountLocalTime]": this
                            .formData["LE_saleOrderDetails.accountLocalTime"]
                            ? this.formData[
                                  "LE_saleOrderDetails.accountLocalTime"
                              ]
                            : "",
                        "search[IN_lineId]": this.formData.IN_lineId
                            ? this.formData.IN_lineId
                            : "",
                        "search[IN_errorCode]": this.formData.IN_errorCode
                            ? this.formData.IN_errorCode
                            : "",
                        "search[EQ_orderNo]": this.formData.EQ_orderNo
                            ? this.formData.EQ_orderNo
                            : "",
                        "search[IN_orderType]": this.formData.IN_orderType
                            ? this.formData.IN_orderType
                            : "",

                        "search[EQ_saleOrderItemsList.sellerSku]": this
                            .formData["EQ_saleOrderItemsList.sellerSku"]
                            ? this.formData["EQ_saleOrderItemsList.sellerSku"]
                            : "",
                        "search[IN_orgWarehouseId]": this.formData
                            .IN_orgWarehouseId
                            ? this.formData.IN_orgWarehouseId
                            : "",
                        "search[GE_shipmentDate]": this.formData.GE_shipmentDate
                            ? this.formData.GE_shipmentDate
                            : "",
                        "search[LE_shipmentDate]": this.formData.LE_shipmentDate
                            ? this.formData.LE_shipmentDate
                            : "",
                        "search[GE_latestShipDate]": this.formData
                            .GE_latestShipDate
                            ? this.formData.GE_latestShipDate
                            : "",
                        "search[LE_latestShipDate]": this.formData
                            .LE_latestShipDate
                            ? this.formData.LE_latestShipDate
                            : "",
                        "search[EQ_fulfillmentChannel]": this.formData
                            .EQ_fulfillmentChannel
                            ? this.formData.EQ_fulfillmentChannel
                            : "",
                        "search[EQ_saleOrderItemsList.erpSku]": this.formData[
                            "EQ_saleOrderItemsList.erpSku"
                        ]
                            ? this.formData["EQ_saleOrderItemsList.erpSku"]
                            : "",
                        "search['EQ_saleShipmentPackagesList.trackNo']": this
                            .formData["EQ_saleShipmentPackagesList.trackNo"]
                            ? this.formData[
                                  "EQ_saleShipmentPackagesList.trackNo"
                              ]
                            : "",

                        "search[EQ_saleOrderAddressList.state]": this.formData[
                            "EQ_saleOrderAddressList.state"
                        ]
                            ? this.formData["EQ_saleOrderAddressList.state"]
                            : "",

                        "search[EQ_b2cOrderSign]": this.formData.EQ_b2cOrderSign
                            ? this.formData.EQ_b2cOrderSign
                            : "",
                        "search[EQ_isPrime]": this.formData.EQ_isPrime
                            ? this.formData.EQ_isPrime
                            : "",
                        "search[EQ_isBusinessOrder]": this.formData
                            .EQ_isBusinessOrder
                            ? this.formData.EQ_isBusinessOrder
                            : "",
                        "search[EQ_saleOrderItemsList.promotionIds]": this
                            .formData["EQ_saleOrderItemsList.promotionIds"]
                            ? this.formData[
                                  "EQ_saleOrderItemsList.promotionIds"
                              ]
                            : "",
                        EQ_orderClass: this.formData.EQ_orderClass
                            ? this.formData.EQ_orderClass
                            : "",
                        "search[IN_saleShipmentPackagesList.logisticStatus]":
                            this.formData[
                                "IN_saleShipmentPackagesList.logisticStatus"
                            ]
                                ? this.formData[
                                      "IN_saleShipmentPackagesList.logisticStatus"
                                  ]
                                : "",
                        "search[EQ_isAddition]": this.allisAddition,

                        "search[IN_id]": this.formData.IN_id
                            ? this.formData.IN_id
                            : "",
                        "search[IN_orderNo]": this.formData.IN_orderNo
                            ? this.formData.IN_orderNo
                            : "",

                        "search[EQ_poNumber]": this.formData.EQ_poNumber
                            ? this.formData.EQ_poNumber
                            : "",
                        "search[EQ_isOnsite]": this.formData.EQ_isOnsite
                            ? this.formData.EQ_isOnsite
                            : "",
                        "search[IN_shippingMethodCode]": this.formData
                            .IN_shippingMethodCode
                            ? this.formData.IN_shippingMethodCode
                            : "",
                        orgWarehouseCodes: this.orgWarehouseCodes
                            ? this.orgWarehouseCodes
                            : [],
                        adminFlag: 1,
                        "search[EQ_parentId]": this.formData.EQ_parentId
                            ? this.formData.EQ_parentId
                            : "",
                        "search[IN_orgId]": this.formData.IN_orgId
                            ? this.formData.IN_orgId
                            : "",
                        timeoutFlag: this.changekeys == "chaoshi" ? 1 : 0,
                    },
                    {
                        executor: "request",
                        download: true,
                    }
                ).catch((err) => {
                    // this.$VMessage.error(err.message);
                });
            }
        },
        handleBtn(key, val, index) {
            this.changestatus = val;
            this.changekeys = key;
            // console.log(this.changestatus)
            // console.log(key)
            if (this.changekeys == "") {
                this.timehandle();
            } else {
                this.getdate = [];
                this.formData.GE_channelCreated = "";
                this.formData.LE_channelCreated = "";

                this.getOrderDate = [];
                this.formData["GE_saleOrderDetails.accountLocalTime"] = "";
                this.formData["LE_saleOrderDetails.accountLocalTime"] = "";

                this.getshipdate = [];
                this.formData.GE_shipmentDate = "";
                this.formData.LE_shipmentDate = "";

                this.getlatesdate = [];
                this.formData.GE_latestShipDate = "";
                this.formData.LE_latestShipDate = "";
                // 切换到其他的tab把存储关闭
                this.resetformdata();
                localStorage.set("b2csearch", null);
                localStorage.set("b2cflag", false);
            }
            this.update("search", { btnkey: key, btnval: val });
            // this.formData
        },
        createTime(data) {
            this.formData.GE_channelCreated = data[0];
            this.formData.LE_channelCreated = data[1];
        },
        orderTime(data) {
            this.formData["GE_saleOrderDetails.accountLocalTime"] = data[0];
            this.formData["LE_saleOrderDetails.accountLocalTime"] = data[1];
        },
        handleChange(date) {
            this.formData.GE_shipmentDate = date[0];
            this.formData.LE_shipmentDate = date[1];
        },
        handleChangelates(date) {
            this.formData.GE_latestShipDate = date[0];
            this.formData.LE_latestShipDate = date[1];
        },
    },
};
</script>
